module.exports = __webpack_public_path__ + "static/media/Forest.70ed21f6.svg";